import { Button, Form, Input, Modal, Select, Space } from "antd";
import TextArea from "antd/es/input/TextArea";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../context";

const EditBusiness = ({ open, close, data, getMyMerchantInfo }) => {
  const [provinceList, setProvinceList] = useState({ data: [], ready: false });
  const [cityList, setCityList] = useState({ data: [], ready: false });
  const [barangayList, setBarangayList] = useState({ data: [], ready: false });
  const { userData } = useContext(UserInfo);
  const { rerunNotif } = useContext(NotificationInfo);
  const [form] = Form.useForm();
  const [allowEdit, setAllowEdit] = useState(true);

  const getAllProvinces = () => {
    axios
      .get("user/merchant/province-list")
      .then((response) => {
        const data = response.data;
        setProvinceList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };

  const handleGetCityByProvince = (value) => {
    var params = { province_description: value };
    setCityList({ data: [], ready: false });
    setBarangayList({ data: [], ready: false });
    form.setFieldsValue({
      business_province: value,
      business_city: "",
      business_barangay: "",
    });
    setAllowEdit(false);
    axios
      .get("user/merchant/city-list", { params })
      .then((response) => {
        const data = response.data;
        setCityList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };

  const handleGetBarangayByCity = (value) => {
    var params = { city_municipality_description: value };
    setBarangayList({ data: [], ready: false });
    form.setFieldsValue({
      business_city: value,
      business_barangay: "",
    });
    axios
      .get("user/merchant/barangay-list", { params })
      .then((response) => {
        const data = response.data;
        setBarangayList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };

  useEffect(() => {
    getAllProvinces();
  }, []);

  const handleUpdateBusinessCom = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    for (const name in values) {
      formdata.append(name, values[name]);
    }
    axios
      .post("user/merchant/update-business", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Updated business successfully.");
          setTimeout(() => {
            close();
            getMyMerchantInfo();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
      });
  };

  return (
    <Modal
      title=""
      open={open}
      onCancel={() => close()}
      footer={null}
      width={350}
      centered
    >
      <Form
        layout="vertical"
        name="edit-business1"
        initialValues={{
          business_name: data.business_name,
          business_authorized_name: data.business_authorized_name,
          business_authorized_position: data.business_authorized_position,
          business_province: data.business_province,
          business_city: data.business_city,
          business_barangay: data.business_barangay,
          business_street: data.business_street,
        }}
        onFinish={handleUpdateBusinessCom}
        autoComplete="off"
        form={form}
      >
        <Space
          direction="vertical"
          style={{ width: "100%", margin: 0, marginTop: 20 }}
        >
          <Form.Item
            id="business_name"
            name="business_name"
            label="Business Name"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Input placeholder="Set business" size="large" />
          </Form.Item>

          <Form.Item
            id="business_authorized_name"
            name="business_authorized_name"
            label="Business Authorized Name"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Input placeholder="Set authorized name" size="large" />
          </Form.Item>

          <Form.Item
            id="business_authorized_position"
            name="business_authorized_position"
            label="Business Authorized Position"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Input placeholder="Set authorized position" size="large" />
          </Form.Item>

          <Form.Item
            id="business_province"
            name="business_province"
            label="Province"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Select
              placeholder="Select province"
              onChange={handleGetCityByProvince}
              size="large"
              showSearch
            >
              {provinceList.data.length > 0 &&
                provinceList.data.map((data, index) => (
                  <Select.Option value={data.province_description} key={index}>
                    {data.province_description}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>

          {form.getFieldValue("business_province") !== null &&
            form.getFieldValue("business_province") !== "" && (
              <Form.Item
                id="business_city"
                name="business_city"
                label="City"
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
              >
                <Select
                  placeholder="Select city"
                  onChange={handleGetBarangayByCity}
                  size="large"
                  showSearch
                  disabled={allowEdit}
                >
                  {cityList.data.length > 0 &&
                    cityList.data.map((data, index) => (
                      <Select.Option
                        value={data.city_municipality_description}
                        key={index}
                        // disabled={
                        //   data.business_city ===
                        //   form.getFieldValue("business_city")
                        // }
                      >
                        {data.city_municipality_description}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>
            )}

          {form.getFieldValue("business_city") !== null &&
            form.getFieldValue("business_city") !== "" && (
              <>
                <Form.Item
                  id="business_barangay"
                  name="business_barangay"
                  label="Barangay"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <Select
                    placeholder="Select barangay"
                    // onChange={handleGetValueBarangay}
                    size="large"
                    showSearch
                    style={{ textTransform: "uppercase" }}
                    disabled={allowEdit}
                  >
                    {barangayList.data.length > 0 &&
                      barangayList.data.map((data, index) => (
                        <Select.Option
                          value={data.barangay_description}
                          key={index}
                          // style={{ textTransform: "uppercase" }}
                        >
                          {data.barangay_description}
                        </Select.Option>
                      ))}
                  </Select>
                </Form.Item>

                <Form.Item
                  id="business_street"
                  name="business_street"
                  label="Street|House No.|Bldg. No.|Apartment"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <TextArea
                    // placeholder="Set street/house/bldg./apt"
                    autoSize
                    size="large"
                    style={{ textTransform: "uppercase" }}
                    disabled={allowEdit}
                  />
                </Form.Item>
              </>
            )}
        </Space>

        <Form.Item style={{ marginTop: "20px" }}>
          <Button
            type="primary"
            htmlType="submit"
            style={{ width: "100%", borderRadius: "20px" }}
          >
            Update
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditBusiness;
